import { propertyName, propertyAttr } from "@/const/character";
import { EquipEntry } from "../equipmentType";
// 词条池
const entryPool = {
  STRV: {
    name: propertyName.STR,
    type: propertyAttr.STR,
    isPercent: false,
    value: 5
  },
  STRV2: {
    name: propertyName.STR,
    type: propertyAttr.STR,
    isPercent: false,
    value: 10
  },
  VITV: {
    name: propertyName.VIT,
    type: propertyAttr.VIT,
    isPercent: false,
    value: 5
  },
  VITV2: {
    name: propertyName.VIT,
    type: propertyAttr.VIT,
    isPercent: false,
    value: 10
  },
  HPV: {
    name: propertyName.HP,
    type: propertyAttr.HP,
    isPercent: false,
    value: 30
  },
  HPV2: {
    name: propertyName.HP,
    type: propertyAttr.HP,
    isPercent: false,
    value: 60
  },
  ATKV: {
    name: propertyName.ATK,
    type: propertyAttr.ATK,
    isPercent: false,
    value: 10
  },
  ATKV2: {
    name: propertyName.ATK,
    type: propertyAttr.ATK,
    isPercent: false,
    value: 18
  },
  DEXV: {
    name: propertyName.DEX,
    type: propertyAttr.DEX,
    isPercent: false,
    value: 5
  },
  DEXV2: {
    name: propertyName.DEX,
    type: propertyAttr.DEX,
    isPercent: false,
    value: 10
  },
  DEFV: {
    name: propertyName.DEF,
    type: propertyAttr.DEF,
    isPercent: false,
    value: 20
  },
  DEFV2: {
    name: propertyName.DEF,
    type: propertyAttr.DEF,
    isPercent: false,
    value: 40
  },
  CRRV: {
    name: propertyName.CRR,
    type: propertyAttr.CRR,
    isPercent: false,
    value: 0.05
  },
  CRRV2: {
    name: propertyName.CRR,
    type: propertyAttr.CRR,
    isPercent: false,
    value: 0.1
  },
  ASV: {
    name: propertyName.AS,
    type: propertyAttr.AS,
    isPercent: false,
    value: 0.1
  },
  ASV2: {
    name: propertyName.AS,
    type: propertyAttr.AS,
    isPercent: false,
    value: 0.2
  },
  CRDV: {
    name: propertyName.CRD,
    type: propertyAttr.CRD,
    isPercent: false,
    value: 0.05
  },
  CRDV2: {
    name: propertyName.CRD,
    type: propertyAttr.CRD,
    isPercent: false,
    value: 0.1
  },
  CRDV3: {
    name: propertyName.CRD,
    type: propertyAttr.CRD,
    isPercent: false,
    value: 0.2
  }
};
const entryDeBuffPool = {
  DASV: {
    name: propertyName.AS,
    type: propertyAttr.AS,
    isPercent: false,
    value: -0.05
  },
  DCRDV: {
    name: propertyName.CRD,
    type: propertyAttr.CRD,
    isPercent: false,
    value: -0.05
  }
};
const entryDeBuffPoolList: EquipEntry[] = Object.values(entryDeBuffPool);
const entryPoolList: EquipEntry[] = Object.values(entryPool);
export { entryPool, entryPoolList, entryDeBuffPool, entryDeBuffPoolList };
